import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { api, mediaUrl } from "../services/api";
import { formatPrice } from "../utils/formatPrice";
import { StatusBadge } from "../utils/orderStatus";
import { Skeleton } from "../components/ui/skeleton";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/my").then((r) => setOrders(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="container-queen pt-32 pb-24" id="main">
      <p className="label-eyebrow text-[#C5A880] mb-2">Suivi &amp; Historique</p>
      <h1 className="font-display text-[#111111] mb-10 text-4xl sm:text-5xl">Mes Commandes</h1>

      {loading ? (
        <div className="space-y-4">{Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-32 w-full rounded-2xl" />)}</div>
      ) : orders.length === 0 ? (
        <div className="text-center py-24 bg-[#F8F8F6] rounded-3xl border border-[#EAE8E4]">
          <div className="w-16 h-16 rounded-full bg-white grid place-items-center mx-auto text-[#111111] shadow-sm"><Package size={28} /></div>
          <h2 className="font-display text-2xl text-[#111111] mt-6">Aucune commande pour le moment</h2>
          <Link to="/shop" className="btn-queen-primary mt-6 text-xs uppercase tracking-wider">Découvrir les Sérums</Link>
        </div>
      ) : (
        <div className="space-y-5 max-w-3xl">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-2xl border border-[#EAE8E4] p-6" data-testid={`order-${o.order_number}`}>
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div>
                  <p className="font-display text-xl text-[#111111]">#{o.order_number}</p>
                  <p className="text-xs text-[#888888]">{o.created_at ? format(new Date(o.created_at), "d MMMM yyyy", { locale: fr }) : ""}</p>
                </div>
                <StatusBadge status={o.status} />
              </div>
              <div className="flex items-center gap-3 mt-5">
                {o.items.slice(0, 4).map((it, i) => (
                  <div key={i} className="rounded-xl overflow-hidden bg-[#F8F8F6] border border-[#EAE8E4] p-1 w-12 h-14">
                    <img src={mediaUrl(it.product_image)} alt={it.product_name} className="w-full h-full object-contain mix-blend-multiply" />
                  </div>
                ))}
                {o.items.length > 4 && <span className="text-xs text-[#888888]">+{o.items.length - 4}</span>}
              </div>
              <div className="flex items-center justify-between mt-5 pt-4 border-t border-[#EAE8E4]">
                <span className="text-xs text-[#666666]">{o.items.length} soin{o.items.length > 1 ? "s" : ""} · {o.wilaya}</span>
                <span className="font-body text-base font-semibold text-[#111111]">{formatPrice(o.total)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
